import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAtomValue } from "jotai";
import { LoaderIcon, UploadIcon } from "lucide-react";
import { statsDateRangeAtom } from "@/stores/atoms/stats-date-range-atom";
import { statsRepo } from "@/lib/repositories";
import { Button } from "@/components/ui/button";

const StatisticsPageHeader = () => {
  const { t } = useTranslation();
  const range = useAtomValue(statsDateRangeAtom);
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    setIsExporting(true);
    try {
      const blob = await statsRepo.exportExcel({
        start_date: range.start_date,
        end_date: range.end_date,
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      const currentDate = new Date().toISOString().slice(0, 10);
      a.download = `exported-statistics-${currentDate}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="flex-1 flex items-center justify-between">
      <h1 className="text-lg">{t("titles.dashboard.stats")}</h1>
      <Button variant="outline" onClick={handleExport} disabled={isExporting}>
        {isExporting ? <LoaderIcon className="animate-spin" /> : <UploadIcon />}
        <span className="hidden md:inline">
          {t("modules.stats.export_excel")}
        </span>
      </Button>
    </div>
  );
};

export default StatisticsPageHeader;
